
import Viz from './VizComponent'

export default Viz
